import FileReference from '@kaizenplatform/belfast-entity/dist/entity/FileReference';
import { useCallback, useContext, useEffect, useState } from 'react';

import { context as DependencyContext } from '../../context/dependency';

const useGetModificationRequestAssetsQuery = (modificationRequests: Array<{ bucketId?: string | null }>) => {
  const dependency = useContext(DependencyContext);
  const [assetFiles, setAssetFiles] = useState<FileReference[]>([]);
  const [loading, setLoading] = useState(0);
  const fetchData = useCallback(async () => {
    setLoading((loading) => ++loading);
    try {
      const bucketIds = modificationRequests
        .map((modificationRequest) => modificationRequest.bucketId)
        .filter((bucketId): bucketId is string => bucketId != null);
      const reses = await Promise.all(
        bucketIds.map((bucketId) =>
          dependency.filesWebApi
            .fetchToken({
              type: 'bucket',
              bucketType: 'modification_request',
              bucketId: bucketId,
            })
            .then((token) => dependency.belfastClient.getAllFilesInBucket(bucketId, token)),
        ),
      );
      setAssetFiles(reses.flat());
    } catch (err) {
      dependency.errorPresenter.showAsNonFatal(err);
    } finally {
      setLoading((loading) => --loading);
    }
  }, [modificationRequests, dependency.filesWebApi, dependency.belfastClient, dependency.errorPresenter]);

  useEffect(() => {
    if (modificationRequests.length > 0) {
      fetchData();
    }
  }, [fetchData, modificationRequests]);

  return { assetFiles, loading: loading > 0 };
};

export default useGetModificationRequestAssetsQuery;
